<div>
  <div *ngIf="!budget">
    <div class="title">
      <span>Presupuesto Adjunto</span>
    </div>
    <div>
     <span class="budget-link"><i class="fa fa-file-invoice-dollar"></i> Cargando Presupuesto...</span>
     &nbsp;&nbsp;<span class="status-name">Espere un momento...</span>
    </div>
  </div>
 
  <div *ngIf="budget">
    <div class="title">
      <span>Presupuesto Adjunto</span>
    </div>
    <div>
      <span
        class="budget-link"
        go-to-details
        [element]="{id: budget.id, type: 'Budget'}"
        mode="route"
      >
        <i class="fa fa-file-invoice-dollar"></i> Presupuesto Nº {{budget.correlative_id}}
      </span>
     &nbsp;&nbsp;<span class="status-name"><i class="fas fa-check-circle" [style.color]="budget.status.color"></i>&nbsp;{{budget.status.name}}</span>  
    </div>
    <div class="subtitle">
      <span *ngIf="value.work.type==='Work::Order'">* El trabajo se podrá completar cuando el presupuesto alcance su estado final.</span>
      <span *ngIf="value.work.type==='Work::Budget'">Total: {{budget.total | money}}.</span>
    </div>
  </div>
</div>
